import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CertificateService {
  constructor(private http: HttpClient) { }

  getCertificate<T>(shareServiceUrl: string, uid: string): Observable<T | null> {
    const url = `${shareServiceUrl}/api/certificates/${uid}`;
    
    return this.http.get<T>(url).pipe(
      catchError((error: HttpErrorResponse) => {
        // Error handling
        console.error('Error fetching certificate', error);
        return of(null); // or any default value as needed
      })
    );
  }
}